import $ from "jquery";

require("datatables.net-bs");
require("datatables.net-bs4/js/dataTables.bootstrap4.js");
require("datatables.net-bs4/css/dataTables.bootstrap4.css");

function initDatatables() {
  if (!$.fn.DataTable) return;

  $("#user-table").DataTable({
    aoColumnDefs: [
      {
        bSortable: false,
        aTargets: ["nosort"],
      },
    ],
    language: {
      lengthMenu: "Show per page _MENU_",
      searchPlaceholder: "Search for username, email and role",
      search: "",
    },
  });

  $("#product-table").DataTable({
    aoColumnDefs: [
      {
        bSortable: false,
        aTargets: ["nosort"],
      },
    ],
    language: {
      lengthMenu: "Show per page _MENU_",
    },
  });
}

export default initDatatables;
